import React from 'react'

function LogoImg({ src, alt, styles }) {
  return (
    <img className={styles} src={src} alt={alt} />
  )
}

export default LogoImg